import { useEffect, useState } from 'react';

import useApi from 'utils/hooks/api/useApi';
import { ALERT_VARIANTS } from 'utils/constants';
import { useRoot } from 'context/RootContext';
import { useTranslation } from 'react-i18next';
import { LOCALIZATION_PAGES, API_ENDPOINTS } from 'utils/constants';
import { HTTP_VERBS } from 'utils/constants';

const useUpdateSeatType = id => {
  const { t } = useTranslation(LOCALIZATION_PAGES.SEAT_TYPES);
  const { showNotification } = useRoot();
  const [path, setPath] = useState(`${API_ENDPOINTS.SEAT_TYPES}/${id}`);

  useEffect(() => {
    setPath(`${API_ENDPOINTS.SEAT_TYPES}/${id}`);
  }, [id]);

  const [
    { result: updateSeatTypeResult, loading: loadingUpdateSeatType, error: errorSeatType },
    updateSeatType,
  ] = useApi(path, {
    initialFetch: false,
    verb: HTTP_VERBS.PUT,
  });

  useEffect(() => {
    if (errorSeatType) {
      showNotification(
        {
          message: t('alert_update_fail'),
        },
        ALERT_VARIANTS.DANGER
      );
    }
  }, [errorSeatType, showNotification, t]);

  useEffect(() => {
    if (updateSeatTypeResult) {
      showNotification({
        message: t('alert_update_success'),
      });
    }
  }, [updateSeatTypeResult, showNotification, t]);

  return [{ updateSeatTypeResult, loadingUpdateSeatType, errorSeatType }, updateSeatType];
};

export default useUpdateSeatType;
